<template>
  <div id="paidFeatures">
    <div class="container">

      <div class="page-title">
        <div class="name">{{ $t('paid_features.title') }}</div>
        <button class="save btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

      <Tabs>
        <TabSection :title="$t('paid_features.features')" collapsible>
          <TipBox :title="$t('tips.sms_feature.title')" warning no-border>
            <p>{{ $t('tips.sms_feature.description') }}</p>
            <ul>
              <li v-html="$t('tips.sms_feature.li_1')"></li>
              <li v-html="$t('tips.sms_feature.li_2')"></li>
            </ul>
          </TipBox>
          <div class="group">
            <label>{{ $t('paid_features.smsActivated') }}</label>
            <select v-model="config.smsActivated">
              <option :value="true">{{ $t('yes') }}</option>
              <option :value="false">{{ $t('no') }}</option>
            </select>
          </div>

          <template v-if="branch && branch.payAtTheTable && branch.payAtTheTable.activated">
            <hr class="dashed">
            <TipBox :title="$t('tips.qr_payment.title')" warning no-border>
              <span v-html="$t('tips.qr_payment.description')"></span>
            </TipBox>
            <TipsPayAtTheTableStatus></TipsPayAtTheTableStatus>
            <div class="group">
              <label>{{ $t('paid_features.qr_payment_activated') }}</label>
              <select v-model="config.payAtTheTable.activated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
          </template>
        </TabSection>
      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import TipsPayAtTheTableStatus from "@/components/tips/TipsPayAtTheTableStatus.vue";

  export default {
    name: 'paidFeatures',

    components: { TipsPayAtTheTableStatus },

    data() {
      return {
        config: {
          smsActivated: false,
          payAtTheTable: {
            activated: false
          }
        }
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      companyId() {
        return this.$route.query.company;
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "paid_features.title";
      this.$store.state.pageIcon = "/icon/services.svg";
      let response = await this.getCompany({
        branchId: this.branchId,
        companyId: this.companyId,
        fallback: false
      });
      this.mapResponse(response);
    },

    methods: {
      ...mapActions(['getCompany', 'saveCompany']),

      mapResponse(response) {
        for (let k of Object.keys(this.config)) {
          this.config[k] = response[k] || false
        }
      },

      async save() {
        this.$store.commit("showSpinner", true);
        let response = await this.saveCompany({
          branchId: this.branchId,
          companyId: this.companyId,
          data: this.config
        });
        this.$store.commit("showSpinner", false);
        if (response) {
          this.mapResponse(response);
          this.$store.commit("setContextCompany", {
            branchId: this.$route.query.branch,
            companyId: this.$route.query.company
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #paidFeatures {
    display: flex;
  }

  hr.dashed {
    border: none;
    border-top: 1px dashed #e6e6e6;
    margin: 30px 0;
  }
</style>
